import type { CanvasEvent, HoverEvent } from '../CanvasEvent';
import CanvasObject from '../CanvasObject';
import type SurfaceBase from '../SurfaceBase';
import type { LngLat } from '../SurfaceBase';
import VertexObject from '../VertexObject';

export default class DrawMarkerObject extends CanvasObject {
  pointerVertex: VertexObject;
  onMarker: (o: LngLat) => void;

  constructor(id: string, surface: SurfaceBase, onMarker: (p: LngLat) => void) {
    super(id, surface);
    this.pointerVertex = new VertexObject('pointer', this.surface, {
      point: { x: NaN, y: NaN },
      lngLat: { lng: NaN, lat: NaN },
    });
    this.addChild(this.pointerVertex);
    this.onMarker = onMarker;
  }

  onSurfaceTap = (e: CanvasEvent) => {
    this.onMarker(e.lngLat);
    e.stopBubble();
  };

  onPointerMove = (e: HoverEvent) => {
    this.pointerVertex.setCoords(e);
    this.surface.renderAll();
  };

  render(ctx: CanvasRenderingContext2D) {
    // there is nothing to render
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string): void {
    // no hit area since we're not drawing anything!
  }
}
